// @flow
import typeof { resources } from 'node/resources/routes';

declare var __SERVER__: boolean;

// Flowtype to extract an instance of a class. (The opposite of "Class<T>")
/* eslint-disable no-unused-vars */
type _$InstanceOf<Instance, C: Class<Instance>> = Instance;
/* eslint-enable no-unused-vars */
// $FlowFixMe Flow v0.104.0 upgrade supression.
type $InstanceOf<C> = _$InstanceOf<*, C>;

// A ResourceClient is just a clientside representation of the actual
// resource, which only exists on the server.
type ResourceClient<Resource> = {|
  name: $PropertyType<Resource, 'name'>,
  options: $PropertyType<Resource, 'options'>,
  getResourceUrl: $PropertyType<Resource, 'getResourceUrl'>,
  callGet: $PropertyType<Resource, 'callGet'> &
    ((
      params?: { showError: boolean },
      mro?: Object,
      headers?: Object,
    ) => $Call<$PropertyType<Resource, 'callGet'>>),
  callCreate: $PropertyType<Resource, 'callCreate'> &
    ((
      params?: { showError: boolean },
      mro?: Object,
      headers?: Object,
    ) => $Call<$PropertyType<Resource, 'callCreate'>>),
  callUpdate: $PropertyType<Resource, 'callUpdate'> &
    ((
      params?: { showError: boolean },
      mro?: Object,
      headers?: Object,
    ) => $Call<$PropertyType<Resource, 'callUpdate'>>),
  callDelete: $PropertyType<Resource, 'callDelete'> &
    ((
      params?: { showError: boolean },
      mro?: Object,
      headers?: Object,
    ) => $Call<$PropertyType<Resource, 'callDelete'>>),
  latestBookmark: $PropertyType<Resource, 'latestBookmark'> &
    (() => $Call<$PropertyType<Resource, 'latestBookmark'>>),
|};

export type ResourceFactory = {
  /* global Name */
  create: <Name: $Keys<resources>>(
    name: Name,
    options?: Object,
  ) => ResourceClient<$InstanceOf<$ElementType<resources, Name>>>,
};

export default ((__SERVER__
  ? require('app/common/lib/ResourceFactory/server').staticWarning
  : require('app/common/lib/ResourceFactory/browser').default): ResourceFactory);
